export default __webpack_public_path__ + "static/media/contactPlaceholder.6fb20873.svg";